module.exports = __webpack_public_path__ + "static/media/05-treinamento.7622d277.png";